export default __webpack_public_path__ + "static/2-516f6dc908cabadca9e587056d757643.jpeg";